/* gr-collection.js — Collection page only.
 * - Filter form: auto-submit on change (debounced)
 * - Mobile filter drawer open/close
 * - AJAX filtering / sort / popstate
 * Quick-add drawer logic split out to gr-product-card.js 2026-05-06.
 */
(function () {
  'use strict';

  function grBuildPriceUrl(container) {
    var minEl = container.querySelector('[data-gr-price-min]');
    var maxEl = container.querySelector('[data-gr-price-max]');
    var min = (minEl && minEl.value || '').trim();
    var max = (maxEl && maxEl.value || '').trim();
    var nMin = parseFloat(min), nMax = parseFloat(max);
    if (!isNaN(nMin) && !isNaN(nMax) && nMin > nMax) { var t = min; min = max; max = t; nMin = parseFloat(min); nMax = parseFloat(max); }
    var u = new URL(location.href);
    if (min !== '' && !isNaN(nMin)) u.searchParams.set('filter.v.price.gte', Math.max(0, nMin)); else u.searchParams.delete('filter.v.price.gte');
    if (max !== '' && !isNaN(nMax)) u.searchParams.set('filter.v.price.lte', Math.max(0, nMax)); else u.searchParams.delete('filter.v.price.lte');
    u.searchParams.delete('page');
    return u.toString();
  }

  // ── MOBILE FILTER SHEET ──────────────────────────────────
  // Delegated + driven by a <body> class so it survives the AJAX section
  // re-render below (the whole [data-gr-coll-section] is swapped on each
  // filter tap). The active-count badge is rendered server-side in Liquid.
  function grCloseFilterSheet() {
    document.body.classList.remove('gr-coll-filters-open');
    var btn = document.querySelector('[data-gr-coll-filter-btn]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-gr-coll-filter-btn]');
    if (openBtn) {
      document.body.classList.add('gr-coll-filters-open');
      openBtn.setAttribute('aria-expanded', 'true');
      return;
    }
    if (e.target.closest('[data-gr-coll-filter-close]') ||
        e.target.classList.contains('gr-coll__filters-scrim')) {
      grCloseFilterSheet();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('gr-coll-filters-open')) {
      grCloseFilterSheet();
    }
  });

  // ── AJAX FILTERING ────────────────────────────────────────
  (function initCollectionAjax() {
    var collSection = document.querySelector('[data-gr-coll-section]');
    if (!collSection) return;
    var sid = collSection.dataset.sectionId;
    if (!sid) return;

    function fetchAndReplace(url) {
      var grid = collSection.querySelector('[data-gr-coll-grid]');
      if (grid) grid.style.opacity = '0.35';
      collSection.style.pointerEvents = 'none';

      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + sid)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var tmp = document.createElement('div');
          tmp.insertAdjacentHTML('beforeend', html);
          var fresh = tmp.querySelector('[data-gr-coll-section]') || tmp.querySelector('.gr-coll') || tmp.firstElementChild;
          if (fresh) {
            collSection.parentNode.replaceChild(fresh, collSection);
            collSection = fresh;
            // Keep the (body-class-driven) sheet's button state in sync
            // after the section markup is replaced.
            if (document.body.classList.contains('gr-coll-filters-open')) {
              var nb = collSection.querySelector('[data-gr-coll-filter-btn]');
              if (nb) nb.setAttribute('aria-expanded', 'true');
            }
            // Let section-specific scripts (e.g. search column density)
            // re-apply state after their markup was replaced.
            document.dispatchEvent(new CustomEvent('gr:coll:replaced'));
          }
          history.pushState(null, '', url);
        })
        .catch(function() { location.href = url; });
    }

    document.addEventListener('click', function(e) {
      var link = e.target.closest('.gr-coll__chip, .gr-coll__pill, .gr-coll__filters-clear');
      if (link && link.href) {
        e.preventDefault();
        fetchAndReplace(link.href);
      }
    });
    document.addEventListener('click', function(e) {
      var apply = e.target.closest('[data-gr-price-apply]');
      if (!apply) return;
      e.preventDefault();
      var box = apply.closest('[data-gr-price-filter]');
      if (box) fetchAndReplace(grBuildPriceUrl(box));
    });
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter') return;
      if (!e.target.matches || !e.target.matches('[data-gr-price-min],[data-gr-price-max]')) return;
      e.preventDefault();
      var box = e.target.closest('[data-gr-price-filter]');
      if (box) fetchAndReplace(grBuildPriceUrl(box));
    });

    document.addEventListener('change', function(e) {
      if (e.target.matches && e.target.matches('[data-gr-coll-sort]')) {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', e.target.value);
        u.searchParams.delete('page');
        fetchAndReplace(u.toString());
      }
    });

    window.addEventListener('popstate', function() { fetchAndReplace(location.href); });
  })();

})();
